import { useState, useEffect } from 'react';
import { Outlet } from 'react-router';
import { MarketingHeader } from './MarketingHeader';
import { MarketingFooter } from './MarketingFooter';
import { CookieConsentBanner, PreferencesModal } from '@/components/CookieConsent';
import { hasConsentDecision, storeConsentPreferences } from '@/utils/cookie-consent';

export const MarketingLayout = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if user has already made a consent decision
    if (!hasConsentDecision()) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    storeConsentPreferences({
      essential: true,
      analytics: true,
      marketing: true,
    });
    setShowBanner(false);
  };

  const handleRejectAll = () => {
    storeConsentPreferences({
      essential: true,
      analytics: false,
      marketing: false,
    });
    setShowBanner(false);
  };

  const handleCustomize = () => {
    setShowModal(true);
  };

  const handleModalSave = () => {
    setShowBanner(false);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <MarketingHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <MarketingFooter />

      {/* Cookie Consent Banner */}
      {showBanner && (
        <CookieConsentBanner
          onAcceptAll={handleAcceptAll}
          onRejectAll={handleRejectAll}
          onCustomize={handleCustomize}
        />
      )}

      {/* Cookie Preferences Modal */}
      <PreferencesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleModalSave}
      />
    </div>
  );
};
